import { useEffect } from 'react';

import browser from '@openclassrooms/utils/browser';

interface Props {
  elementId: string;
  target?: HTMLElement;
  shouldKeepElAfterUnmount?: boolean;
}

export default function HTMLToggler({
  elementId,
  target,
  shouldKeepElAfterUnmount = false,
}: Props) {
  useEffect(() => {
    const domElement = browser.document.getElementById(elementId);

    if (!domElement) {
      return () => {};
    }

    if (target) {
      target.appendChild(domElement);
    }

    domElement.style.display = 'block';

    return () => {
      domElement.style.display = 'none';
      if (shouldKeepElAfterUnmount) {
        browser.document.body.appendChild(domElement);
      }
    };
  }, [elementId, target, shouldKeepElAfterUnmount]);

  return null;
}
